/* eslint-disable prefer-spread */
import axios from 'axios';
import { nextEventLoop } from 'helpers/timing';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = {
    src: String,
    pollingTime: {
      type: Number,
      default: 5,
    },
    loading: {
      type: String,
      default: 'lazy',
    },
    stopPollingId: String,
    pollingId: String,
  };

  controller = new AbortController();

  initialize() {
    if (this.targetContainer) {
      this.poller = null;
      const originalURL = window.location.href;

      this.poller = setInterval(() => {
        const pollerKiller = document.getElementById(this.stopPollingIdValue);

        if (this.loadingValue === 'lazy' && window.location.href === originalURL && !pollerKiller) {
          this.makeRequest();
        } else {
          clearInterval(this.poller);
        }

        // }, this.pollingTimeValue * 1000);
        // (Kevin) - hard coding this to 5 seconds for now
        // I think the current implementation of
        // this.pollingTimeValue * 1000 risks us
        // making the user wait too long for a result
      }, 5000);
    }
  }

  disconnect() {
    clearInterval(this.poller);
  }

  async makeRequest() {
    if (!this.hasSrcValue || !this.srcValue) return;

    this.controller?.abort();
    this.controller = new AbortController();

    try {
      const data = await makeNetworkRequest(this.element, this.srcValue, {
        headers: {
          accept: 'text/fragment+html',
          credentials: 'same-origin',
        },
        signal: this.controller.signal,
      });

      this.targetContainer.innerHTML = data;

      if (document.getElementById(this.stopPollingIdValue)) {
        // for the session recording index (on the patient show page),
        // do not clear the session-recording table
        // when polling is closed

        clearInterval(this.poller);

        if (this.stopPollingIdValue !== 'stop-poller-checks-sr-idx') {
          document.getElementById(this.pollingIdValue).remove();
        }

        if (
          this.stopPollingIdValue === 'stop-poller-checks-vnog' ||
          this.stopPollingIdValue === 'stop-poller-checks-srp' ||
          this.stopPollingIdValue === 'stop-poller-checks-vnpsg' ||
          this.stopPollingIdValue === 'stop-poller-checks-cms1500'
        ) {
          reloadPage();
        }
      }

      this.dispatch('success', { bubbles: true });
      this.controller = null;
    } catch (error) {
      if (!axios.isCancel(error)) {
        this.dispatch('error', { bubbles: true });
        this.controller = null;
      }
    }
  }

  // Private

  get targetContainer() {
    const element = this.element.getAttribute('aria-controls');
    return document.getElementById(element);
  }
}

async function makeNetworkRequest(el, src, options) {
  // Mimic `<img>` event dispatch order ['loadstart', 'load/error', 'loadend']
  try {
    el.dispatchEvent(new CustomEvent('loadstart'));
    const { data } = await axios.get(src, options);
    el.dispatchEvent(new CustomEvent('load'));
    el.dispatchEvent(new CustomEvent('loadend'));
    await nextEventLoop();
    return data;
  } catch (error) {
    el.dispatchEvent(new CustomEvent('error'));
    el.dispatchEvent(new CustomEvent('loadend'));
    await nextEventLoop();
    throw error;
  }
}

// Poller hack to refresh page and remount JS libraries
async function reloadPage() {
  window.scrollPosition = [window.scrollX, window.scrollY + 10];
  window.location.reload();
}
